import Phaser from 'phaser';
import { MainMenuScene } from './scenes/MainMenuScene';
import { GameScene } from './scenes/GameScene';
import { GameOverScene } from './scenes/GameOverScene';
import { SettingsScene } from './scenes/SettingsScene';
import { LeaderboardScene } from './scenes/LeaderboardScene';
import { activePalette, css } from './util/palette';

// `?debug=1` overlays Matter collider wireframes so the physics body can be
// compared against the rendered candy silhouette. Off by default.
const COLLIDER_DEBUG =
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('debug') === '1';

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  // Match the persisted palette so the canvas clear color never flashes dark
  // behind a light theme (or vice versa) between scene transitions.
  backgroundColor: css(activePalette().bgBottom),
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  input: {
    activePointers: 3,
  },
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: 1 },
      debug: COLLIDER_DEBUG
        ? { showBody: true, showStaticBody: true, lineColor: 0x00ff88, lineThickness: 2, fillColor: 0x00ff88, fillOpacity: 0.12 }
        : false,
      enableSleeping: false,
      // Higher iteration counts help the solver push penetrating bodies back
      // out when the container walls teleport via setPosition during rotation.
      positionIterations: 12,
      velocityIterations: 10,
      constraintIterations: 4,
    },
  },
  scene: [MainMenuScene, GameScene, GameOverScene, SettingsScene, LeaderboardScene],
};
